import React from 'react';

import cx from 'classnames';

import Divider from 'components/shared/Divider';

import styles from './index.module.css';
import ManifestTable from './Table';

function Manifest() {
  return (
    <div className={cx(styles.container, 'custom-manifest-container')}>
      <ManifestTable />
      <Divider />
    </div>
  );
}

export default Manifest;
